import { LanguageEnum } from 'graphql-common';

export function getLangLabel(lang: LanguageEnum) {
  switch (lang) {
    case LanguageEnum.En:
      return 'English';
    case LanguageEnum.Fr:
      return 'Français';
    case LanguageEnum.Ro:
      return 'Română';
    case LanguageEnum.Uk:
      return 'Українська';
    case LanguageEnum.Pl:
      return 'Polski';
    case LanguageEnum.Es:
      return 'Español';
    default:
      return '-';
  }
}

const fullLangs = Object.values(LanguageEnum);

export const langOptions = fullLangs.map((lang) => ({
  label: getLangLabel(lang),
  value: lang,
}));

// Unfiltered by environment: used where every supported language must stay
// selectable regardless of VITE_ENVIRONMENT (e.g. admin/company creation).
export const fullLangOptions = fullLangs.map((lang) => ({
  label: getLangLabel(lang),
  value: lang,
}));

const langFlagCodes: Record<LanguageEnum, string> = {
  [LanguageEnum.En]: 'gb',
  [LanguageEnum.Es]: 'es',
  [LanguageEnum.Fr]: 'fr',
  [LanguageEnum.Pl]: 'pl',
  [LanguageEnum.Ro]: 'ro',
  [LanguageEnum.Uk]: 'ua',
};

export function getLangFlagCode(lang: LanguageEnum) {
  return langFlagCodes[lang] ?? '';
}
